import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SummaryMain from "../components/summary/SummaryMain.jsx";
import {
    loadSummaryData,
    loadSummaryData2
} from '../actions';

class SummaryMainContainer extends React.Component {
    render() {
        return (
            <div>
                <SummaryMain {...this.props} />
            </div>
        );
    }
}

SummaryMainContainer.propTypes = {
    profileDetails: PropTypes.object.isRequired
};


const mapStateToProps = (state, ownProps) => ({
    profileDetails: state.profileDetails
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadSummaryData: () => {
      //dispatch(loadSummaryData2());
    dispatch(loadSummaryData());
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(SummaryMainContainer);



// WEBPACK FOOTER //
// ./src/containers/SummaryMainContainer.js